export class RichTextModalArgs {

    constructor(
        protected title: string,
        protected value: string,
        protected defaultValue?: string,
        protected templateLookupTypeId?: string
    ) {}

    getTitle(): string {
        return this.title;
    }

    getValue(): string {
        return this.value || this.defaultValue || '';
    }

    getDefaultValue(): string {
        return this.defaultValue;
    }

    getTemplateLookupTypeId(): string {
        return this.templateLookupTypeId;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/rich-text/form/rich-text-control-modal-args.model.ts